/*
Designed By R.Sanjai
Created : 24/08/2023
Screen : Log-in
*/

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate, NavLink } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { FiEye, FiEyeOff } from "react-icons/fi"; // Assuming you've imported the eye icons

import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './login.css';
import 'react-notifications-component/dist/theme.css'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useJwt } from "react-jwt";

import { security_key, BASE_URL } from "../global";
import { fetchAccessibleServices } from "../serviceAccess";

// TOP: ADD NEW IMPORTS
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { getCountryIso2 } from "./Util";
import { getUserSetting } from "./UserSetting";
import dayjs from "dayjs";
import updateLocale from 'dayjs/plugin/updateLocale';


//const passwordRules = /^(?=.*[a-z])(?=.*[A-Z]).{5,}$/;

const basicSchema = yup.object().shape({
    ca_login_id: yup.string().required("A username is required.").min(2, "Minimum 2 characters is required.").matches(/^[^\s]+$/, "Not allowed whitespaces."),
    ca_password: yup.string().min(5, "Minimum 5 characters is required.").required("A password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma").matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/, "Avoid apostrophe & quotes."),

});

function _getCountryIso2(isoSubDivisionCode) {

    return getCountryIso2(isoSubDivisionCode)
}

function Login() {
    const [IsContent, setContent] = useState([]);
    const [IsMaintenance, setMaintenance] = useState([]);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);


    const navigate = useNavigate();


    const [showTC, setTCShow] = useState(false);


    const [IsContentFilter, setContentFilter] = useState([]);

    const [isAdminCheck, setIsAdminCheck] = useState(null);
    const [token, setToken] = useState(null);

    const location = useLocation();

    const [showForceTCModal, setShowForceTCModal] = useState(false);
    const [latestTC, setLatestTC] = useState(null);
    const [tcAgreeChecked, setTCAgreeChecked] = useState(false);
    const [showForcePrivacyModal, setShowForcePrivacyModal] = useState(false);
    const [latestPrivacy, setLatestPrivacy] = useState(null);
    const [privacyAgreeChecked, setPrivacyAgreeChecked] = useState(false);
    const [isPolicyLoading, setPolicyLoading] = useState(true);

    useEffect(() => {
        document.title = 'TCMS';
        const checkAdminStatus = async () => {
            const isAdminValue = sessionStorage.getItem('is_admin');
            if (isAdminValue !== null && isAdminValue === '0') {
                navigate("/calendar-v2");
            } else {
                setIsAdminCheck(false); // Set state to indicate that the condition is checked
            }
        };

        const fetchAll = async () => {
            try {
                setPolicyLoading(true); // <-- START loading
                const [termsRes, privacyRes, contentRes, maintenanceRes] = await Promise.all([
                    axios.post(BASE_URL + 'API/api_index.php', {
                        security_key: security_key,
                        mode: "getLatestContentByType",
                        content_type: "terms"
                    }),
                    axios.post(BASE_URL + 'API/api_index.php', {
                        security_key: security_key,
                        mode: "getLatestContentByType",
                        content_type: "privacy"
                    }),
                    axios.post(BASE_URL + 'API/api_index.php', {
                        security_key: security_key,
                        mode: "getAllContent"
                    }),
                    axios.post(BASE_URL + 'API/api_index.php', {
                        security_key: security_key,
                        mode: "TCMSMaintenance"
                    }),
                ]);

                if (termsRes.data.success) setLatestTC(termsRes.data.data);
                if (privacyRes.data.success) setLatestPrivacy(privacyRes.data.data);
                if (contentRes.data.success) setContent(contentRes.data.data);
                if (maintenanceRes.data.success) setMaintenance(maintenanceRes.data.data[0]);
            } catch (err) {
                console.error("Parallel loading error:", err);
            } finally {
                setPolicyLoading(false); // <-- END loading
            }
        };


        fetchAll();
        checkAdminStatus();
    }, [location]);


    const axiosInstance = axios.create({
        baseURL: BASE_URL,
        timeout: 3000,
        headers: { Authorization: `bearer ${token}` },
    });

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getAllContent"
            });

            if (response.data.success === true) {
                setContent(response.data.data);


            } else {
                //alert message provide

                console.error('Error fetching data');
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchMaintenance = async () => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "TCMSMaintenance"
            });

            if (response.data.success === true) {
                setMaintenance(response.data.data[0]);


            } else {
                //alert message provide

                console.error('Error fetching data');
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm(); // Reset Formik-controlled fields
        setValues({
            ...initialValues, // Reset select fields
        });
    };

    const initialValues = {
        /*tbl_center_auth*/
        ca_login_id: "", //Not in db
        ca_password: "",
    };

    const { values, handleBlur, touched, handleChange, errors, handleSubmit, setTouched, resetForm, setValues } =
        useFormik({
            // const formik = useFormik({
            initialValues,
            validationSchema: basicSchema,
            // onSubmit,
            onSubmit: async (formValues) => {
                // Disable the submit button and reset alerts
                setIsSubmitting(true);



                try {
                    const response = await axios.post(BASE_URL + "API/api_index.php", {
                        security_key: security_key,
                        mode: 'getSingleCenterAuth_jwt',
                        ...formValues,
                    });

                    if (response.data.success === true) {
                        // Reset the form

                        if (response.data.data.length > 0) {

                            resetFormFields(resetForm, setValues, initialValues);

                            if (response.data.data[0]['pk_cent_key'] !== '') {

                                sessionStorage.setItem('key', response.data.data[0]['pk_cent_key']);
                                sessionStorage.setItem('is_admin', '0');
                                sessionStorage.setItem('center_name', response.data.data[0]['cent_name']);
                                sessionStorage.setItem('first_name', response.data.data[0]['ci_first_name']);
                                sessionStorage.setItem('sur_name', response.data.data[0]['ci_surname']);
                                sessionStorage.setItem('time_zone', response.data.data[0]['cent_timezone']);
                                sessionStorage.setItem('timezone_identifier', response.data.data[0]['cent_timezone_identifier']);
                                sessionStorage.setItem('user_id', response.data.data[0]['pk_ci_id']);
                                //user_type
                                //0- Center super admin and admin.
                                //1- staff
                                sessionStorage.setItem('user_type', response.data.data[0]['user_type']);


                                sessionStorage.setItem('country_alph_code', response.data.data[0]['country_code']); //This stores country subdivision code (eg. GB-SCT)
                                sessionStorage.setItem('country_iso2', _getCountryIso2(response.data.data[0]['country_code']));
                                sessionStorage.setItem('country_code', response.data.data[0]['cent_country']);
                                sessionStorage.setItem('currency_code', response.data.data[0]['country_currency']);
                                sessionStorage.setItem('cent_profile', response.data.data[0]['cent_profile']);
                                sessionStorage.setItem('token', response.data.token);

                                sessionStorage.setItem('isSuccess', '1');

                                // Centre flagged "Not Paid" by super admin: backend sends the notice
                                // with the token; PaymentHoldNotice (mounted in CentreRoute) pops it
                                // up once after login and removes the key on OK.
                                if (response.data.payment_hold_notice) {
                                    sessionStorage.setItem('payment_hold_notice', JSON.stringify(response.data.payment_hold_notice));
                                }

                                // Preload the centre's accessible services (token is set above,
                                // so this authenticated call carries its Bearer) so feature-gated
                                // menu items / routes are correct on first paint. Best-effort.
                                await fetchAccessibleServices();

                                const userSetting = getUserSetting();
                                dayjs.extend(updateLocale);
                                dayjs.updateLocale('en', { weekStart: userSetting.calendarInput.firstDay });


                                // After 3 seconds, redirect to another page
                                setTimeout(function () {
                                    fetchTermsAcceptanceStatus();
                                }, 700); // 3000 milliseconds, which is equivalent to 3 seconds

                            } else {



                                toast.error("The entered username or password is wrong.", {
                                    autoClose: 700, // 3 seconds in this example
                                });

                                setIsSubmitting(false); // Re-enable the submit button
                            }

                            // alert("Success! Your form was submitted.");
                            setToken(response.data.token);

                        } else {

                            if (response.data.data.loginAccount == 0) {
                                toast.error("Account inactive, Please contact admin.", {
                                    autoClose: 700, // 3 seconds in this example
                                });

                            } else {
                                toast.error("The entered username or password is wrong.", {
                                    autoClose: 700, // 3 seconds in this example
                                });
                            }


                            setIsSubmitting(false); // Re-enable the submit button
                        }

                    } else {


                        toast.error("The entered username or password is wrong.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmitting(false); // Re-enable the submit button
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);


                    toast.error("The entered username or password is wrong.", {
                        autoClose: 700, // 3 seconds in this example
                    });
                    setIsSubmitting(false); // Re-enable the submit button
                } finally {
                    setIsSubmitting(false); // Re-enable the submit button
                }

            },
        });

    useEffect(() => {
        setTimeout(() => {
            if (token) {
                async function validateToken() {
                    try {

                        const response = await axios.post(BASE_URL + "API/api_index.php", {
                            security_key: security_key,
                            mode: 'checkValidateJWT',
                        });

                        if (response) {


                        }
                    } catch (error) {

                    }
                }

                validateToken();
            }
        }, 1000);
    }, [token, axiosInstance]);

    const [passwordVisible, setPasswordVisible] = useState(false);


    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };


    const fetchTermsAcceptanceStatus = async () => {
        try {
            const res = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "checkUserContentAcceptance",
                fk_user_key: sessionStorage.getItem("key"),
                user_type: sessionStorage.getItem("user_type"),
                content_type: "terms", // terms = T&C for TCMS
            });

            if (res.data.success) {
                if (!res.data.accepted) {
                    setLatestTC(res.data.content);
                    setShowForceTCModal(true);
                } else {
                    fetchPrivacyAcceptanceStatus();
                }
            } else {
                console.error("Failed T&C check");
            }
        } catch (err) {
            console.error("Error checking T&C acceptance:", err);
        }
    };

    // ✅ Save T&C acceptance
    const acceptTCNow = async () => {
        try {
            const save = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "recordUserContentAcceptance",
                fk_user_key: sessionStorage.getItem("key"),
                fk_content_key: latestTC?.pk_content_key,
                user_type: sessionStorage.getItem("user_type"),
            });
            console.log("T&C Acceptance API Response:", save.data);
            if (save.data.success) {
                setShowForceTCModal(false);
                fetchPrivacyAcceptanceStatus();
            } else {
                toast.error("Failed to record acceptance.");
                console.log("Backend response:", save.data);
            }
        } catch (e) {
            toast.error("Error saving T&C acceptance.");
        }
    };

    const fetchPrivacyAcceptanceStatus = async () => {
        try {
            const res = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "checkUserContentAcceptance",
                fk_user_key: sessionStorage.getItem("key"),
                user_type: sessionStorage.getItem("user_type"),
                content_type: "privacy", // privacy = Privacy Policy
            });

            if (res.data.success) {
                if (!res.data.accepted) {
                    setLatestPrivacy(res.data.content);
                    setShowForcePrivacyModal(true);
                } else {
                    navigate("/calendar-v2");
                }
            } else {
                console.error("Failed Privacy Policy check");
            }
        } catch (err) {
            console.error("Error checking Privacy Policy acceptance:", err);
        }
    };

    const acceptPrivacyNow = async () => {
        try {
            const save = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "recordUserContentAcceptance",
                fk_user_key: sessionStorage.getItem("key"),
                fk_content_key: latestPrivacy?.pk_content_key,
                user_type: sessionStorage.getItem("user_type"),
            });

            if (save.data.success) {
                setShowForcePrivacyModal(false);
                navigate("/calendar-v2");
            } else {
                toast.error("Failed to record Privacy Policy acceptance.");
            }
        } catch (e) {
            toast.error("Error saving Privacy Policy acceptance.");
        }
    };

    const fetchLatestContentByType = async (type, setterFn) => {
        try {
            const res = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "getLatestContentByType",
                content_type: type,
            });

            if (res.data.success && res.data.data) {
                setterFn(res.data.data);
            }
        } catch (err) {
            console.error("Error fetching content type", type, err);
        }
    };


    return (
        <>{isAdminCheck !== null ? (
            <>
                <ToastContainer position="top-center" />
                {IsMaintenance ? IsMaintenance.sm_narration && IsMaintenance.sm_narration != '' && parseInt(IsMaintenance.is_visible) == 0 ? (
                    <div className='headerlogin'>
                        <div className='d-flex justify-content-between'>
                            <span><WarningRoundedIcon color="warning" /> Scheduled maintenance</span>
                            <span className='mt-1'>{IsMaintenance ? IsMaintenance.sm_narration && IsMaintenance.sm_narration != null && IsMaintenance.sm_narration != '' ? IsMaintenance.sm_narration : null : null}</span>
                        </div>
                    </div>) : null : null}
                <Modal show={showTC} onHide={() => setTCShow(false)}

                    aria-labelledby="contained-modal-title-vcenter"
                    centered size="xl">
                    <Modal.Header closeButton>{IsContentFilter && IsContentFilter.content_title != '' ? IsContentFilter.content_title : ''}</Modal.Header>
                    <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>

                        {IsContentFilter?.content_details ? (

                            <div>
                                {/* Loop through each element in IsContent using map */}
                                {/* {IsContentFilter.map((item, index) => (
          <div key={index}> */}
                                <h6><strong>{IsContentFilter.content_subject}</strong></h6>
                                {/* <p>{item.content_subject}</p> */}
                                <div dangerouslySetInnerHTML={{ __html: IsContentFilter.content_details }} />

                                {/* </div>
        ))} */}
                            </div>
                        ) : (
                            <div>No content available</div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className='pt-0'>
                        <div className="mx-auto d-flex gap-2">
                            <Button variant="contained" className="primary-gray" onClick={() => setTCShow(false)}>
                                Ok
                            </Button>
                            {/* Additional buttons or actions */}
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showForceTCModal}
                    onHide={() => { }}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title>{latestTC?.content_title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <h6><strong>{latestTC?.content_subject}</strong></h6>
                        <div dangerouslySetInnerHTML={{ __html: latestTC?.content_details }} />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={tcAgreeChecked}
                                    onChange={(e) => setTCAgreeChecked(e.target.checked)}
                                />
                            }
                            label="I accept the Terms and Conditions"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="primary-filled"
                            onClick={acceptTCNow}
                            disabled={!tcAgreeChecked}
                        >
                            Proceed
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showForcePrivacyModal}
                    onHide={() => { }}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title>{latestPrivacy?.content_title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <h6><strong>{latestPrivacy?.content_subject}</strong></h6>
                        <div dangerouslySetInnerHTML={{ __html: latestPrivacy?.content_details }} />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={privacyAgreeChecked}
                                    onChange={(e) => setPrivacyAgreeChecked(e.target.checked)}
                                />
                            }
                            label="I acknowledge and accept the Privacy Policy"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="primary-filled"
                            onClick={acceptPrivacyNow}
                            disabled={!privacyAgreeChecked}
                        >
                            Proceed
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef} className='page-center cus-login mx-auto'>

                    <Container className='position-relative cus-form'>


                        <Row className='bg-white justify-content-center rounded-15 p-3'>
                            <Col xs="12" md="12" lg="12">

                                <div className='justify-content-center'>
                                    <div className='text-center'>
                                        <img src="mygooroo-tcms.png" width={150} className="page-center mb-2" />
                                        <p className="text-center para">Tutoring Centre Management System (TCMS)</p>
                                    </div>

                                    <div className='mt-4'>
                                        <div className='position-relative'>
                                            <h6 className="form-lable required-field">Username</h6>
                                            <Form.Control
                                                type="text"

                                                value={values.ca_login_id}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                id="ca_login_id"
                                                className={errors.ca_login_id && touched.ca_login_id ? "input-error" : ""}
                                            />
                                            {errors.ca_login_id && touched.ca_login_id && <p className="lo-error">{errors.ca_login_id}</p>}
                                        </div>
                                        <div className='position-relative'>
                                            <h6 className="form-lable required-field">Password</h6>

                                            <Form.Control
                                                type={passwordVisible ? "text" : "password"}

                                                value={values.ca_password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                id="ca_password"

                                                className={errors.ca_password && touched.ca_password ? "input-error"
                                                    : ""}
                                            />
                                            <button
                                                type="button"
                                                onClick={togglePasswordVisibility}
                                                className="password-toggle-button pswlgin" title="show / hide"
                                            >
                                                {passwordVisible ? <FiEye /> : <FiEyeOff />}

                                            </button>
                                            {errors.ca_password && touched.ca_password && <p className="lo-error">{errors.ca_password}</p>}

                                        </div>

                                        <div className='text-center'>

                                            <Button type="submit" variant="contained" className='primary-filled w-100 py-2 mt-3'
                                                disabled={isSubmitting}>Sign in</Button>

                                        </div>

                                    </div>
                                </div>
                            </Col>

                        </Row>
                        {/* <Row> 
                            <Col> */}

                        <div className='w-100 mt-4'>
                            <div className='cus-log-btm text-center'>

                                {isPolicyLoading ? (
                                    <span className="text-muted small">Loading policies...</span>
                                ) : (
                                    <>
                                        <NavLink
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setContentFilter(latestTC);
                                                setTCShow(true);
                                            }}
                                        >
                                            {latestTC?.content_title || "Terms & Conditions"}
                                        </NavLink>

                                        <span className="mx-2">|</span>

                                        <NavLink
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setContentFilter(latestPrivacy);
                                                setTCShow(true);
                                            }}
                                        >
                                            {latestPrivacy?.content_title || "Privacy Policy"}
                                        </NavLink>
                                    </>
                                )}

                            </div>
                        </div>



                        {/* </Col>

                </Row> */}
                    </Container>

                </Form > </>) : (null)
        }
        </>
    );
}

export default Login;